import axios from 'axios';
import _ from 'lodash';
import { getBrowser } from 'utils/Platform';
import { getHKS } from 'utils/HKS';
import { getRegion } from './../../../utils/Region';

export const updatePassword = (params = {}) =>
  axios
    .get(`${process.env.URL_DOMINIO_MICROFWK}/services/user/password`, {
      params: {
        ...params,
        ...window.getConfig.config.general.api_params_default,
        device_so: getBrowser(),
        HKS: getHKS(),
        region: getRegion(),
      },
    })
    .then(({ data }) => {
      const status = _.get(data, 'status', _.get(data, 'response.status', 0));
      if (parseInt(status, 10) !== 0) {
        const error = _.get(data, 'response', data);
        return error !== null ? error : data;
      }
      return data.response;
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
